//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React from 'react';
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';

function Page() {
  const nutrients = useStore((state) => state.nutrients);
  const setNutrients = useStore((state) => state.setNutrients);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.nutrients.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={nutrients}
          onChange={(value) => {
            setNutrients(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'nutrients',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'I do!'}>
            <span>✅</span>
            {t('onboarding.nutrients.options.iDo')}
          </Option>
          <Option value={'I check from time to time'}>
            <span>📊</span>
            {t('onboarding.nutrients.options.check')}
          </Option>
          <Option value={'Not really'}>
            <span>🚫</span>
            {t('onboarding.nutrients.options.notReally')}
          </Option>
        </Check>
      </div>
    </div>
  );
}
export default Page;
